import BaseAPI from './base'

class TeacherGifCardAPI extends BaseAPI {}

export default new TeacherGifCardAPI('v1/teacher-gift-card', 'TeacherGifCard')
